module.exports = __webpack_public_path__ + "static/media/health-program_p0_1.057e91c9.png";